import { create } from 'zustand';
import useLoadingStore from './use-loading';
import { makeRequest } from 'api/api-client';
import { HTTP } from 'constants/http-method';
import { API_ENDPOINTS } from 'api/endpoints';
import { getProfile, setProfile } from 'utils/profile-storage';

const { profile } = getProfile();

const useProfileStore = create((set) => ({
  profile: profile || null,

  // Function to fetch user profile
  fetchProfile: async ({ successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.VIEW_PROFILE
      );
      if (response.success) {
        setProfile(response.data?.profile);
        set({ profile: response.data?.profile });
        successCallback && successCallback(response.data?.profile);
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update user profile
  updateProfile: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.UPDATE_PROFILE,
        data
      );
      if (response.success) {
        setProfile(response.data.user);
        set({ profile: response.data?.user });
        successCallback && successCallback();
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to change password
  accountChangePassword: async ({ data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.POST,
        API_ENDPOINTS.ACCOUNT_CHANGE_PASSWORD,
        data
      );
      response.success && successCallback(response.message);
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to reset profile
  resetProfile: () => set({ profile: null }),
}));

export default useProfileStore;
